var map = {
	"./abruzzowines/denominazione/Classi&DenomW200.png": 598,
	"./abruzzowines/denominazione/Classi&DenomW400.png": 52752,
	"./abruzzowines/denominazione/Classificazione&DenominazioneW200.png": 84203,
	"./abruzzowines/denominazione/Classificazione&DenominazioneW500.png": 27116,
	"./abruzzowines/denominazione/ConsorzioAbruzzoW200.png": 10511,
	"./abruzzowines/denominazione/ConsorzioAbruzzoW500.png": 97288,
	"./abruzzowines/denominazione/DenomDOC&GW200.png": 28612,
	"./abruzzowines/denominazione/DenomDOC&GW400.png": 56386,
	"./abruzzowines/denominazione/DenomIGTDOCH200.png": 24122,
	"./abruzzowines/denominazione/DenomIGTDOCH400.png": 27836,
	"./abruzzowines/denominazione/DenominazioneDOCGDOPW200.png": 92340,
	"./abruzzowines/denominazione/DenominazioneDOCGDOPW400.png": 56402,
	"./abruzzowines/denominazione/DenominazioneIGTIGW200.png": 17470,
	"./abruzzowines/denominazione/DenominazioneIGTIGW400.png": 13880,
	"./abruzzowines/denominazione/DenominazioneIGTW200.png": 14966,
	"./abruzzowines/denominazione/DenominazioneIGTW400.png": 59792,
	"./abruzzowines/denominazione/etichettaWineW200.png": 91076,
	"./abruzzowines/denominazione/etichettaWineW400.png": 2498,
	"./abruzzowines/gamma/BianchiH200.png": 1816,
	"./abruzzowines/gamma/BianchiH400.png": 5406,
	"./abruzzowines/gamma/DolciH200.png": 34249,
	"./abruzzowines/gamma/DolciH400.png": 60975,
	"./abruzzowines/gamma/DolciviniH200.png": 53749,
	"./abruzzowines/gamma/DolciviniH400.png": 30355,
	"./abruzzowines/gamma/Rosso&RosatoH200.png": 68980,
	"./abruzzowines/gamma/Rosso&RosatoH400.png": 25042,
	"./abruzzowines/gamma/SpumantiMCharmatH200.png": 8308,
	"./abruzzowines/gamma/SpumantiMCharmatH400.png": 60466,
	"./abruzzowines/gamma/SpumantiMClassicoH200.png": 45835,
	"./abruzzowines/gamma/SpumantiMClassicoH400.png": 68621,
	"./abruzzowines/intestato/CantineAbruzzoW1200.png": 9697,
	"./abruzzowines/intestato/CantineAbruzzoW1600.png": 61221,
	"./abruzzowines/intestato/CantineAbruzzoW2000.png": 9978,
	"./abruzzowines/intestato/CantineAbruzzoW3500.png": 37608,
	"./abruzzowines/intestato/CantineAbruzzoW500.png": 67023,
	"./abruzzowines/intestato/CantineAbruzzoW800.png": 80114,
	"./abruzzowines/intestato/EventiViniABW1200.png": 16734,
	"./abruzzowines/intestato/EventiViniABW1600.png": 26298,
	"./abruzzowines/intestato/EventiViniABW2000.png": 42409,
	"./abruzzowines/intestato/EventiViniABW3500.png": 86563,
	"./abruzzowines/intestato/EventiViniABW500.png": 66234,
	"./abruzzowines/intestato/EventiViniABW800.png": 13895,
	"./abruzzowines/intestato/EventiViniAbruzzo.png": 80138,
	"./abruzzowines/intestato/GammDeiVini.png": 88604,
	"./abruzzowines/intestato/Regolamentazione.png": 46240,
	"./abruzzowines/intestato/storiadelvino.png": 85089,
	"./abruzzowines/intestato/vigneto.png": 15226,
	"./abruzzowines/storia/CicloDellaVitaH200.png": 50809,
	"./abruzzowines/storia/CicloDellaVitaH400.png": 84415,
	"./abruzzowines/storia/FeniciH200.png": 31285,
	"./abruzzowines/storia/FeniciH400.png": 79379,
	"./abruzzowines/storia/GreciH200.png": 90093,
	"./abruzzowines/storia/GreciH400.png": 48075,
	"./abruzzowines/storia/ViteH200.png": 91383,
	"./abruzzowines/storia/ViteH400.png": 20593,
	"./abruzzowines/storia/ViteTreeH200.png": 55947,
	"./abruzzowines/storia/ViteTreeH400.png": 78733,
	"./abruzzowines/storia/ViteTwoH200.png": 75321,
	"./abruzzowines/storia/ViteTwoH400.png": 8927,
	"./abruzzowines/storia/VitisSylvesFiveH200.png": 81250,
	"./abruzzowines/storia/VitisSylvesFiveH400.png": 82916,
	"./abruzzowines/storia/VitisSylvesFourH200.png": 42770,
	"./abruzzowines/storia/VitisSylvesFourH400.png": 86708,
	"./abruzzowines/storia/VitisSylvesOneH200.png": 11616,
	"./abruzzowines/storia/VitisSylvesOneH400.png": 24422,
	"./abruzzowines/storia/VitisSylvesSevenH200.png": 12951,
	"./abruzzowines/storia/VitisSylvesSevenH400.png": 45713,
	"./abruzzowines/storia/VitisSylvesSixH200.png": 16380,
	"./abruzzowines/storia/VitisSylvesSixH400.png": 12666,
	"./abruzzowines/storia/VitisSylvesTwoH200.png": 52774,
	"./abruzzowines/storia/VitisSylvesTwoH400.png": 85056,
	"./abruzzowines/storia/acinoH200.png": 40109,
	"./abruzzowines/storia/acinoH400.png": 98091,
	"./abruzzowines/storia/acinoPicH200.png": 94005,
	"./abruzzowines/storia/acinoPicH400.png": 70611,
	"./abruzzowines/storia/vitiviniculturaH200.png": 52869,
	"./abruzzowines/storia/vitiviniculturaH400.png": 63555,
	"./catalogo/espositore/BottleEightH150.png": 83844,
	"./catalogo/espositore/BottleEightH300.png": 5201,
	"./catalogo/espositore/BottleEightH350.png": 46106,
	"./catalogo/espositore/BottleEightH400.png": 7158,
	"./catalogo/espositore/BottleEightH450.png": 84965,
	"./catalogo/espositore/BottleEightH550.png": 13872,
	"./catalogo/espositore/BottleEightH800.png": 19882,
	"./catalogo/espositore/BottleFiveH150.png": 12377,
	"./catalogo/espositore/BottleFiveH300.png": 99104,
	"./catalogo/espositore/BottleFiveH350.png": 80039,
	"./catalogo/espositore/BottleFiveH400.png": 41927,
	"./catalogo/espositore/BottleFiveH450.png": 60992,
	"./catalogo/espositore/BottleFiveH550.png": 11541,
	"./catalogo/espositore/BottleFiveH800.png": 92475,
	"./catalogo/espositore/BottleFourH150.png": 25261,
	"./catalogo/espositore/BottleFourH300.png": 75868,
	"./catalogo/espositore/BottleFourH350.png": 83243,
	"./catalogo/espositore/BottleFourH400.png": 2491,
	"./catalogo/espositore/BottleFourH450.png": 53004,
	"./catalogo/espositore/BottleFourH550.png": 26417,
	"./catalogo/espositore/BottleFourH800.png": 21319,
	"./catalogo/espositore/BottleOneH150.png": 3373,
	"./catalogo/espositore/BottleOneH300.png": 66492,
	"./catalogo/espositore/BottleOneH350.png": 14955,
	"./catalogo/espositore/BottleOneH400.png": 76955,
	"./catalogo/espositore/BottleOneH450.png": 92844,
	"./catalogo/espositore/BottleOneH550.png": 95025,
	"./catalogo/espositore/BottleOneH800.png": 21831,
	"./catalogo/espositore/BottleSevenH150.png": 41030,
	"./catalogo/espositore/BottleSevenH300.png": 93623,
	"./catalogo/espositore/BottleSevenH350.png": 31504,
	"./catalogo/espositore/BottleSevenH400.png": 69616,
	"./catalogo/espositore/BottleSevenH450.png": 31735,
	"./catalogo/espositore/BottleSevenH550.png": 63738,
	"./catalogo/espositore/BottleSevenH800.png": 23308,
	"./catalogo/espositore/BottleSixH150.png": 42177,
	"./catalogo/espositore/BottleSixH300.png": 55144,
	"./catalogo/espositore/BottleSixH350.png": 6479,
	"./catalogo/espositore/BottleSixH400.png": 68367,
	"./catalogo/espositore/BottleSixH450.png": 17032,
	"./catalogo/espositore/BottleSixH550.png": 56413,
	"./catalogo/espositore/BottleSixH800.png": 13235,
	"./catalogo/espositore/BottleThreeH150.png": 67129,
	"./catalogo/espositore/BottleThreeH300.png": 49408,
	"./catalogo/espositore/BottleThreeH350.png": 53639,
	"./catalogo/espositore/BottleThreeH400.png": 15527,
	"./catalogo/espositore/BottleThreeH450.png": 11296,
	"./catalogo/espositore/BottleThreeH550.png": 85141,
	"./catalogo/espositore/BottleThreeH800.png": 96699,
	"./catalogo/espositore/BottleTwoH150.png": 42491,
	"./catalogo/espositore/BottleTwoH300.png": 7118,
	"./catalogo/espositore/BottleTwoH350.png": 97917,
	"./catalogo/espositore/BottleTwoH400.png": 83145,
	"./catalogo/espositore/BottleTwoH450.png": 84850,
	"./catalogo/espositore/BottleTwoH550.png": 47983,
	"./catalogo/espositore/BottleTwoH800.png": 88629,
	"./catalogo/expo/BirreArtigW280.png": 7898,
	"./catalogo/expo/CavatappiW280.png": 50632,
	"./catalogo/expo/CaveFrigoW280.png": 92217,
	"./catalogo/expo/DistillatiW280.png": 88846,
	"./catalogo/expo/ExpoViniW280.png": 88001,
	"./catalogo/expo/PromoW280.png": 73478,
	"./catalogo/expo/offerteW280.png": 72004,
	"./catalogo/expo/regionaleW280.png": 41479,
	"./catalogo/expo/scatolaSpumanteW280.png": 27721,
	"./catalogo/expo/scatolaVinox4W280.png": 67272,
	"./catalogo/intestato/CatalogoW1200.png": 94563,
	"./catalogo/intestato/CatalogoW1600.png": 36807,
	"./catalogo/intestato/CatalogoW2000.png": 94100,
	"./catalogo/intestato/CatalogoW350.png": 1664,
	"./catalogo/intestato/CatalogoW3500.png": 67970,
	"./catalogo/intestato/CatalogoW500.png": 30561,
	"./catalogo/intestato/CatalogoW800.png": 60444,
	"./catalogo/intestato/espositoreW1200.png": 32942,
	"./catalogo/intestato/espositoreW1600.png": 22538,
	"./catalogo/intestato/espositoreW400.png": 93771,
	"./catalogo/intestato/espositoreW500.png": 67498,
	"./catalogo/intestato/espositoreW800.png": 74967,
	"./catalogo/labelbottiiglie/wineLabelEightRH550.png": 2446,
	"./catalogo/labelbottiiglie/wineLabelEightVH550.png": 19442,
	"./catalogo/labelbottiiglie/wineLabelFiveRH550.png": 6049,
	"./catalogo/labelbottiiglie/wineLabelFiveVH550.png": 51917,
	"./catalogo/labelbottiiglie/wineLabelFourRH550.png": 51209,
	"./catalogo/labelbottiiglie/wineLabelFourVH550.png": 89621,
	"./catalogo/labelbottiiglie/wineLabelOneRH550.png": 64817,
	"./catalogo/labelbottiiglie/wineLabelOneVH550.png": 45501,
	"./catalogo/labelbottiiglie/wineLabelSevenRH550.png": 56816,
	"./catalogo/labelbottiiglie/wineLabelSevenVH550.png": 44564,
	"./catalogo/labelbottiiglie/wineLabelSixRH550.png": 58393,
	"./catalogo/labelbottiiglie/wineLabelSixVH550.png": 94853,
	"./catalogo/labelbottiiglie/wineLabelThreeRH550.png": 16457,
	"./catalogo/labelbottiiglie/wineLabelThreeVH550.png": 1269,
	"./catalogo/labelbottiiglie/wineLabelTwoRH550.png": 37415,
	"./catalogo/labelbottiiglie/wineLabelTwoVH550.png": 85203,
	"./catalogo/navbar/LogoW250.png": 23045,
	"./choosewines/intestato/BuonaSceltaVini.png": 55537,
	"./choosewines/intestato/EtichetteBottiglie.png": 74862,
	"./choosewines/intestato/RegaloVino.png": 68208,
	"./choosewines/intestato/ScegliereViniW1200.png": 73077,
	"./choosewines/intestato/ScegliereViniW1600.png": 76977,
	"./choosewines/intestato/ScegliereViniW2000.png": 33774,
	"./choosewines/intestato/ScegliereViniW3500.png": 13268,
	"./choosewines/intestato/ScegliereViniW500.png": 45395,
	"./choosewines/intestato/ScegliereViniW800.png": 94254,
	"./choosewines/intestato/SceltaVinoEnoteca.png": 88299,
	"./choosewines/intestato/abbinamentoVino.png": 68770,
	"./header/EventiEnogastronomicieW167.png": 6840,
	"./header/LogoW430.png": 549,
	"./header/QuizW167.png": 99902,
	"./header/SagreW167.png": 22779,
	"./header/WineShopW167.png": 44178,
	"./header/mobilemenu/AbruzzoMnW265.png": 91882,
	"./header/mobilemenu/CatalogoMmW265.png": 9934,
	"./header/mobilemenu/ChooseWineMmW265.png": 24858,
	"./header/mobilemenu/EventiEnogastroMmW265.png": 15427,
	"./header/mobilemenu/InfoWineMmW265.png": 65445,
	"./header/mobilemenu/QuizMmW265.png": 48669,
	"./header/mobilemenu/SagreMmW265.png": 39884,
	"./header/mobilemenu/TastingWineMmW265.png": 6235,
	"./header/mobilemenu/TipologiaMmW265.png": 36066,
	"./header/mobilemenu/VitigniMmW265.png": 75954,
	"./header/navbar/AbWinesManifestiW200.png": 93019,
	"./header/navbar/ChooseWinesManifestiW200.png": 78097,
	"./header/navbar/LogoBurgerNavW192SE.png": 69915,
	"./header/navbar/ManifestoEventiEnogastroW200.png": 42857,
	"./header/navbar/ManifestoQuizW200.png": 10289,
	"./header/navbar/ManisfestoSagreW200.png": 81923,
	"./header/navbar/ManisfestoWineShopW200.png": 19206,
	"./header/navbar/TasteWinesManifestiW200.png": 21719,
	"./home/primapagina/ChooseWine.png": 97696,
	"./home/primapagina/InfoWine.png": 4791,
	"./home/primapagina/TastingWine.png": 27105,
	"./home/primapagina/abruzzoWOrW350.png": 42530,
	"./home/primapagina/abruzzoWW350.png": 30837,
	"./home/primapagina/chooseWOrW350.png": 41946,
	"./home/primapagina/chooseWW350.png": 18461,
	"./home/primapagina/tasteWOrW350.png": 45590,
	"./home/primapagina/tasteWW350.png": 11041,
	"./icons/ArrowBackEssH20.png": 43420,
	"./icons/ArrowBackEssOH20.png": 41203,
	"./icons/ArrowBackOH20.png": 70340,
	"./icons/ArrowBackOSH20.png": 7375,
	"./icons/ArrowBackOrW48.png": 23653,
	"./icons/Carrello96ft.png": 18282,
	"./icons/DeliveryTime.png": 37306,
	"./icons/DeliveryTimeOrange.png": 5608,
	"./icons/DenominaIGT.png": 83222,
	"./icons/DenominaIGTW80.png": 44771,
	"./icons/IconCarrelloBaseall.png": 10916,
	"./icons/IconCarrelloBaseallRV.png": 23136,
	"./icons/IconCarrelloBaseallRVW50.png": 13246,
	"./icons/IconCarrelloBaseallW65.png": 95190,
	"./icons/IconCarrelloBaseallW75.png": 20925,
	"./icons/IconCarrelloBaseallW80.png": 58377,
	"./icons/IconCarrelloW65.png": 18648,
	"./icons/IconCarrelloW92.png": 81750,
	"./icons/IconCarrelloYelloW50.png": 35589,
	"./icons/IconFlipEffectW64.png": 79439,
	"./icons/IconFlipEffectW80.png": 36825,
	"./icons/IconFlipEffectW96.png": 8584,
	"./icons/IconInfo.png": 91170,
	"./icons/IconRemove.png": 154,
	"./icons/IconViewBaseall.png": 797,
	"./icons/InfoWindowW210.png": 72781,
	"./icons/InfoWindowW250.png": 90041,
	"./icons/Pagamento.png": 22305,
	"./icons/PagamentoOrange.png": 94659,
	"./icons/Registrati16ft.png": 78422,
	"./icons/Registrati192ft.png": 37439,
	"./icons/Registrati30ft.png": 59962,
	"./icons/Registrati50ft.png": 29468,
	"./icons/Registrati96ft.png": 27390,
	"./icons/Scatolla.png": 44692,
	"./icons/ScatollaOrange.png": 67026,
	"./icons/Search192ft.png": 15519,
	"./icons/Search30ft.png": 16410,
	"./icons/Search50ft.png": 2268,
	"./icons/Search50ftBis.png": 98884,
	"./icons/Search96ft.png": 190,
	"./icons/SearchBlk50ft.png": 42277,
	"./icons/Searchar48.png": 90180,
	"./icons/ShopW40.png": 60374,
	"./icons/ShopW64.png": 89336,
	"./icons/ShoppingW40.png": 90126,
	"./icons/SocialIconAccountW96.png": 52274,
	"./icons/SocialIconInstagramW96.png": 72393,
	"./icons/SocialIconLinkdinW96.png": 34830,
	"./icons/SocialIconPintarestW96.png": 6351,
	"./icons/SocialIconTikTokW96.png": 22531,
	"./icons/SocialIconTwitterW96.png": 26842,
	"./icons/SocialIconWAW96.png": 48753,
	"./icons/SocialIconXW96.png": 32661,
	"./icons/SocialIconYTW96.png": 15508,
	"./icons/SocialIconfbW96.png": 6477,
	"./icons/Utente16.png": 63255,
	"./icons/Utente192.png": 74400,
	"./icons/Utente192ft.png": 71738,
	"./icons/Utente30.png": 90519,
	"./icons/Utente32ft.png": 81123,
	"./icons/Utente50.png": 92309,
	"./icons/Utente50ft.png": 45555,
	"./icons/Utente96.png": 5343,
	"./icons/Utente96ft.png": 70185,
	"./icons/UtenteOranW38.png": 74664,
	"./icons/UtenteOranW50.png": 40886,
	"./icons/UtenteW38.png": 28106,
	"./icons/UtenteW50.png": 16100,
	"./icons/UtenteW80.png": 77931,
	"./icons/cartOranW38.png": 83787,
	"./icons/cartOranW50.png": 83801,
	"./icons/cartW38.png": 19985,
	"./icons/cartW50.png": 9315,
	"./icons/cartW80.png": 67564,
	"./icons/fa-check.png": 12473,
	"./icons/fa-checkf.png": 29627,
	"./icons/iconArrowGW24.png": 90487,
	"./icons/iconDOC.png": 77858,
	"./icons/iconDOCG.png": 73447,
	"./icons/iconDOCGW100.png": 28003,
	"./icons/iconDelPackagingW80.png": 17335,
	"./icons/iconDelivery.png": 49190,
	"./icons/iconDeliveryBlackW60.png": 67412,
	"./icons/iconDeliveryBlackW80.png": 58442,
	"./icons/iconDeliveryW80.png": 36851,
	"./icons/iconHomeNavbar.png": 48713,
	"./icons/iconHomeNavbarGR.png": 34090,
	"./icons/iconHomeNavbarYellow.png": 57561,
	"./icons/iconHomeNavbarYellowGr.png": 28090,
	"./icons/iconIGT.png": 67776,
	"./icons/iconInfoW38.png": 30958,
	"./icons/iconInfoW48.png": 70211,
	"./icons/iconInfoWhiteW38.png": 55677,
	"./icons/iconLenteOBW50.png": 1891,
	"./icons/iconLoginW50.png": 10551,
	"./icons/iconLoginYelloW50.png": 19928,
	"./icons/iconLogout.png": 48280,
	"./icons/iconLogoutW101.png": 39929,
	"./icons/iconLogoutW126.png": 2172,
	"./icons/iconLogoutW50.png": 64230,
	"./icons/iconLogoutW80.png": 33725,
	"./icons/iconOrDelPackagingW80.png": 13010,
	"./icons/iconOrDeliveryW80.png": 17826,
	"./icons/iconOrPagSecuroW103.png": 30503,
	"./icons/iconPackaging.png": 91809,
	"./icons/iconPackagingW48.png": 12822,
	"./icons/iconPackagingW80.png": 79290,
	"./icons/iconPagSecuro.png": 101,
	"./icons/iconPagSecuroBlk50.png": 79387,
	"./icons/iconPagSecuroBlk80.png": 66132,
	"./icons/iconPagSecuroW103.png": 71598,
	"./icons/iconPhone.png": 2404,
	"./icons/iconPhoneW48.png": 18989,
	"./icons/iconPhoneW50.png": 52714,
	"./icons/iconPosition.png": 37911,
	"./icons/iconPromHW100.png": 73446,
	"./icons/iconPromoW100.png": 65133,
	"./icons/iconPromoW32.png": 61933,
	"./icons/iconPromotion.png": 93063,
	"./icons/iconRemovedW28.png": 67743,
	"./icons/iconRemovedWhiteW28.png": 36896,
	"./icons/iconSchedaW50.png": 93522,
	"./icons/iconSchedaW80.png": 82721,
	"./icons/iconSignUpW50.png": 40804,
	"./icons/iconSignUpYelloW50.png": 89201,
	"./icons/iconWineCeller.png": 66136,
	"./icons/lente.png": 61273,
	"./icons/lenteOranW38.png": 51137,
	"./icons/lenteOranW50.png": 46611,
	"./icons/lenteOrange.png": 71675,
	"./icons/lenteW38.png": 79107,
	"./icons/lenteW50.png": 97793,
	"./icons/lenteW80.png": 79506,
	"./icons/searchHCTr.png": 28464,
	"./illustrazione/BiancoRossoH200.png": 38934,
	"./illustrazione/BiancoRossoH400.png": 91088,
	"./illustrazione/BicchiereISOH200.png": 71971,
	"./illustrazione/BicchiereISOH400.png": 91013,
	"./illustrazione/BoteVinoH200.png": 508,
	"./illustrazione/BoteVinoH400.png": 84890,
	"./illustrazione/EtichettaRettoH200.png": 41281,
	"./illustrazione/EtichettaRettoH400.png": 11431,
	"./illustrazione/EtichettaVersoH200.png": 68430,
	"./illustrazione/EtichettaVersoH400.png": 52296,
	"./illustrazione/EtichettatwoRettoH200.png": 28191,
	"./illustrazione/EtichettatwoRettoH400.png": 94585,
	"./illustrazione/EtichettatwoVersoH200.png": 47380,
	"./illustrazione/EtichettatwoVersoH400.png": 69266,
	"./illustrazione/LogoMostoDivino.png": 87638,
	"./illustrazione/LogoMostoDivinoH200.png": 77132,
	"./illustrazione/LogoMostoDivinoH400.png": 19338,
	"./illustrazione/RedWineH200.png": 25882,
	"./illustrazione/RedWineH400.png": 68604,
	"./illustrazione/SaluteH200.png": 7894,
	"./illustrazione/SaluteH400.png": 52720,
	"./illustrazione/Sommelier-560s615.png": 74550,
	"./illustrazione/SommelierH200.png": 13349,
	"./illustrazione/SommelierH400.png": 98499,
	"./illustrazione/SpecimenillustraH200.png": 67256,
	"./illustrazione/SpecimenillustraH400.png": 79166,
	"./illustrazione/TrabuccoH200.png": 71563,
	"./illustrazione/TrabuccoH400.png": 43629,
	"./illustrazione/typeBottleH200.png": 31222,
	"./illustrazione/typeBottleH400.png": 76048,
	"./province/cantine/identita/Cantina5.png": 19596,
	"./province/cantine/identita/CantinaCircleW150.png": 91614,
	"./province/intestato/AbruzzoViniWd1200.png": 64704,
	"./province/intestato/AbruzzoViniWd1600.png": 96836,
	"./province/intestato/AbruzzoViniWd2000.png": 36363,
	"./province/intestato/AbruzzoViniWd350.png": 79577,
	"./province/intestato/AbruzzoViniWd3500.png": 33757,
	"./province/intestato/AbruzzoViniWd500.png": 69636,
	"./province/intestato/AbruzzoViniWd800.png": 41465,
	"./province/intestato/AquilaStemmaW265.png": 50297,
	"./province/intestato/ChietiStemmaW265.png": 12982,
	"./province/intestato/PescaraStemmaW265.png": 51291,
	"./province/intestato/TeramoStemmaW265.png": 34002,
	"./sparetime/quiz/intestato/TraboccoQW1200.png": 53725,
	"./sparetime/quiz/intestato/TraboccoQW1600.png": 1625,
	"./sparetime/quiz/intestato/TraboccoQW2000.png": 71414,
	"./sparetime/quiz/intestato/TraboccoQW3500.png": 47036,
	"./sparetime/quiz/intestato/TraboccoQW500.png": 8139,
	"./sparetime/quiz/intestato/TraboccoQW800.png": 41462,
	"./sparetime/sagre/intestato/TraboccoW1200.png": 39999,
	"./sparetime/sagre/intestato/TraboccoW1600.png": 99867,
	"./sparetime/sagre/intestato/TraboccoW2000.png": 53312,
	"./sparetime/sagre/intestato/TraboccoW3500.png": 53782,
	"./sparetime/sagre/intestato/TraboccoW500.png": 65213,
	"./sparetime/sagre/intestato/TraboccoW800.png": 28352,
	"./tastewines/intestato/DegustationW1200.png": 54345,
	"./tastewines/intestato/DegustationW1600.png": 32749,
	"./tastewines/intestato/DegustationW2000.png": 46389,
	"./tastewines/intestato/DegustationW3500.png": 85488,
	"./tastewines/intestato/DegustationW500.png": 35527,
	"./tastewines/intestato/DegustationW800.png": 81530,
	"./tastewines/intestato/Degustazione.png": 72512,
	"./tastewines/intestato/EsameGustoOlfativoW265.png": 17101,
	"./tastewines/intestato/EsameOlfativoW265.png": 82581,
	"./tastewines/intestato/EsameVisivoW265.png": 6081,
	"./tastewines/intestato/ServicioDelVinoW265.png": 81505,
	"./tipologia/intestato/Cerasuolo.png": 69212,
	"./tipologia/intestato/TipideiVini.png": 40531,
	"./tipologia/intestato/TipideiViniCircleW250.png": 26199,
	"./tipologia/intestato/TipologiaWd1200.png": 66927,
	"./tipologia/intestato/TipologiaWd1600.png": 57867,
	"./tipologia/intestato/TipologiaWd2000.png": 92720,
	"./tipologia/intestato/TipologiaWd350.png": 61372,
	"./tipologia/intestato/TipologiaWd3500.png": 43078,
	"./tipologia/intestato/TipologiaWd500.png": 86349,
	"./tipologia/intestato/TipologiaWd800.png": 95312,
	"./tipologia/intestato/VinificazioneCerasuoloCircleW250.png": 73848,
	"./tipologia/intestato/VinificazioneInBianco.png": 42948,
	"./tipologia/intestato/VinificazioneInBiancoCircleW250.png": 69748,
	"./tipologia/intestato/VinificazioneInRosso.png": 8152,
	"./tipologia/intestato/VinificazioneInRossoCircleW250.png": 84952,
	"./tipologia/vinificazioneinrosso/CappelloDelleVinacceW200.png": 96635,
	"./tipologia/vinificazioneinrosso/CappelloDelleVinacceW500.png": 78844,
	"./tipologia/vinificazioneinrosso/DiraspapigiatriceW200.png": 16959,
	"./tipologia/vinificazioneinrosso/DiraspapigiatriceW500.png": 94392,
	"./tipologia/vinificazioneinrosso/DiraspatriceW200.png": 36017,
	"./tipologia/vinificazioneinrosso/DiraspatriceW500.png": 17430,
	"./tipologia/vinificazioneinrosso/FermentazioneMalolatticaW200.png": 28320,
	"./tipologia/vinificazioneinrosso/FermentazioneMalolatticaW500.png": 37191,
	"./tipologia/vinificazioneinrosso/FrollaturaW200.png": 52036,
	"./tipologia/vinificazioneinrosso/FrollaturaW500.png": 44835,
	"./tipologia/vinificazioneinrosso/ImbottigliamentoW200.png": 84728,
	"./tipologia/vinificazioneinrosso/ImbottigliamentoW500.png": 72671,
	"./tipologia/vinificazioneinrosso/PigiatriceW200.png": 8219,
	"./tipologia/vinificazioneinrosso/PigiatriceW500.png": 74076,
	"./tipologia/vinificazioneinrosso/SerbatoiVetroresinaW200.png": 68263,
	"./tipologia/vinificazioneinrosso/SerbatoiVetroresinaW500.png": 59392,
	"./tipologia/vinificazioneinrosso/SerbatoiW200.png": 41709,
	"./tipologia/vinificazioneinrosso/SerbatoiW500.png": 92394,
	"./tipologia/vinificazioneinrosso/SolfitazioneW200.png": 12719,
	"./tipologia/vinificazioneinrosso/SolfitazioneW500.png": 15848,
	"./tipologia/vinificazioneinrosso/TorchioW200.png": 37568,
	"./tipologia/vinificazioneinrosso/TorchioW500.png": 46439,
	"./tipologia/vinificazioneinrosso/VinacceW200.png": 60529,
	"./tipologia/vinificazioneinrosso/VinacceW500.png": 62486,
	"./tipologia/vinificazioneinrosso/VinoAffinamentoAH200.png": 83376,
	"./tipologia/vinificazioneinrosso/VinoAffinamentoAH400.png": 61526,
	"./tipologia/vinificazioneinrosso/VinoAffinamentoBH200.png": 63723,
	"./tipologia/vinificazioneinrosso/VinoAffinamentoBH400.png": 86509,
	"./tipologia/vinificazioneinrosso/VinoInvecchiatoH200.png": 94752,
	"./tipologia/vinificazioneinrosso/VinoInvecchiatoH400.png": 85766,
	"./vitigno/intestato/InovazioneViticolturaCircleW250.png": 84953,
	"./vitigno/intestato/InovazioneViticolturaW265.png": 56609,
	"./vitigno/intestato/TecnicaDiColtivazioneCircleW250.png": 57388,
	"./vitigno/intestato/TecnicaDiColtivazioneW265.png": 8736,
	"./vitigno/intestato/UvaggioWd1200.png": 90475,
	"./vitigno/intestato/UvaggioWd1600.png": 99535,
	"./vitigno/intestato/UvaggioWd2000.png": 99420,
	"./vitigno/intestato/UvaggioWd350.png": 35640,
	"./vitigno/intestato/UvaggioWd3500.png": 81098,
	"./vitigno/intestato/UvaggioWd500.png": 76505,
	"./vitigno/intestato/UvaggioWd800.png": 16548,
	"./vitigno/intestato/VitignoAutotocnoCococialaW265.png": 51543,
	"./vitigno/intestato/VitignoCococialaCircleW250.png": 77879,
	"./vitigno/intestato/VitignoImportatiCircleW200.png": 37837,
	"./vitigno/intestato/VitignoImportatoW265.png": 98232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83311;